// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** update House Details Start ************************/
export const houseMemberDetailsAdd = (verifyData: any) => {
	const data = {
		CreateMemberHouseDetailsToken: verifyData,
	};
	const url = `${API_URL}addHouseDetails`;
	return makeApiCall(url, data);
};
/** ***************** update House Details End ************************/
